import { showToast } from "@/providers";

export const isValidImage = (file: File): boolean => {
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
  const MAX_SIZE = 10 * 1024 * 1024; // 10MB

  if (!allowedTypes.includes(file.type)) {
    showToast({
      type: "error",
      title: "Tipo de arquivo inválido",
      content: "Envie apenas imagens (JPEG, JPG, PNG, WEBP).",
    });
    return false;
  }

  if (file.size > MAX_SIZE) {
    showToast({
      type: "error",
      title: "Arquivo muito grande",
      content: "A imagem deve ter no máximo 10MB.",
    });
    return false;
  }

  return true;
};
